import { RecurlyWrapper } from '../../../..';
import { BillingProvider } from '../../../../lib/ContextProviders';
import UpdatePaymentFormV2 from './UpdatePaymentFormV2';

export interface UpdatePaymentContainerProps {
  onSuccess: () => void;
  onClose: () => void;
}

export const UpdatePaymentFormV2Container = ({
  onSuccess,
  onClose,
}: UpdatePaymentContainerProps) => (
  <RecurlyWrapper>
    <BillingProvider onSuccess={onSuccess}>
      <UpdatePaymentFormV2 onSuccess={onSuccess} onClose={onClose} />
    </BillingProvider>
  </RecurlyWrapper>
);
